import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  labelStyle: {
    display: 'block',
    color: theme.palette.neutralPrimary,
    marginBottom: pxToRem(8),
  },
  valueStyle: {
    color: theme.palette.neutralPrimary,
    fontWeight: 400,
  },
  keyword: {
    display: 'inline-block',
    background: theme.palette.neutralLighter,
    color: theme.palette.neutralDark,
    fontSize: pxToRem(14),
    padding: `${pxToRem(2)} ${pxToRem(6)}`,
    fontWeight: 400,
    marginRight: pxToRem(6),
    marginBottom: pxToRem(6),
  },
  floatRight: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: pxToRem(20),
  },
  datePicker: {
    width: pxToRem(166),
    selectors: {
      '& .ms-TextField-field': {
        paddingTop: pxToRem(5),
      },
    },
  },
  noBg: {
    background: 'none',
  },
});
